import { useState, useRef, useEffect } from "react";
import { Calendar } from "lucide-react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "../vendor/vendorView.css";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";

const SelectRangeButton = ({ onChange }) => {
  const ref = useRef(null);

  const [open, setOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  /* Close when clicking outside */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* Detect if popover should open upward */
  const toggleCalendar = () => {
    if (!open) {
      const rect = ref.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setOpenUp(spaceBelow < 420);
    }
    setOpen(!open);
  };

  const label =
    startDate && endDate
      ? `${format(startDate, "dd MMM")} - ${format(endDate, "dd MMM")}`
      : "Select range";

  return (
    <div className={`date-range-wrapper ${openUp ? "open-up" : ""}`} ref={ref}>
      <button
        className="select-range-btn"
        onClick={toggleCalendar}
        type="button"
      >
        <span className="fs-13 fw-500 textPurple">{label}</span>
        {startDate && endDate ? (
          <div className="close-icon" onClick={(e) => {
            e.stopPropagation();
            setStartDate(null);
            setEndDate(null);
            if (onChange) onChange({ start: null, end: null });
          }}>
            <ModalCloseIcon />
          </div>
        ) : (
          <Calendar size={16} strokeWidth={2} />
        )}
      </button>

      {open && (
        <div className="date-range-popover">
          <DatePicker
            selected={startDate}
            onChange={(dates) => {
              const [start, end] = dates;
              setStartDate(start);
              setEndDate(end);

              if (onChange) onChange({ start, end });

              if (start && end) {
                setTimeout(() => setOpen(false), 150);
              }
            }}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
          />
        </div>
      )}
    </div>
  );
};

export default SelectRangeButton;
